<script setup>
import EmptyCardComponent from "@/components/cards/EmptyCardComponent.vue";
import {StarIcon} from "@heroicons/vue/16/solid";
import misc from "@/Services/misc";
import CommentForm from "@/components/form/CommentForm.vue";

const props = defineProps({
  reviews: {
    type: Array,
    default: () => []
  }
});
 // hasComment = (review) => {
 //   return review.comments?.length > 0
 // }
</script>

<template>
  <empty-card-component
    v-if="props.reviews.length"
    :has-shadow="false"
    class="mb-4"
  >
    <template #body>
      <ul v-if="reviews?.length > 0">
        <li
          v-for="(review, index) in props.reviews"
          :key="index"
        >
          <div class="mb-4">
            <div
              class="rounded-xl shadow mb-2 p-4 bg-white"
            >
              <div class="flex">
                <span
                  v-for="(item, index2) of misc.convertRatingToBooleanArray(review.rating)"
                  :key="index2"
                >
                  <star-icon :class="['h-5 w-5 rating', item ? 'text-yellow-400' : 'text-gray-400']" />
                </span>
              </div>
              <div class="text-left mt-4 text-gray-500">
                <h4 class="text-base font-semibold text-gray-600 mb-3">
                  {{ review.title }}
                </h4>
                <p class="text-gray-500 text-sm">
                  {{ review.content }}
                </p>
              </div>
              <div class="flex justify-between items-center mt-3 border-t pt-3">
                <div class="flex flex-1 space-x-3 items-center">
                  <img
                    :src="review.reviewedBy.avatar"
                    alt="review-name"
                    class="rounded-full h-8 w-8"
                  >
                  <span class="text-xs text-gray-400 drop-shadow">{{ review.reviewedBy.name }}</span>
                </div>
                <span class=" text-xs text-gray-400 drop-shadow">{{ review.createdAt }}</span>
              </div>
            </div>

            <comment-form
              :review="review"
            />
          </div>
        </li>
      </ul>
    </template>
  </empty-card-component>
</template>

<style scoped>

</style>
